import { render, staticRenderFns } from "./CompanyDetailToTag.vue?vue&type=template&id=818ace48&scoped=true&"
import script from "./CompanyDetailToTag.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailToTag.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailToTag.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CompanyDetailToTag.vue?vue&type=style&index=1&id=818ace48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818ace48",
  null
  
)

export default component.exports